import * as React from 'react';
/**
 *
 * Original name: bug
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A381
 *
 */
export const BugPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M53 35.891v-4h-7v-9h-4a11.839 11.839 0 0 0-2.511-7.91l3.073-3.841-3.123-2.5-3.209 4.011a11.23 11.23 0 0 0-4.23-.76 11.233 11.233 0 0 0-4.229.762l-3.209-4.012-3.123 2.5 3.073 3.841A11.84 11.84 0 0 0 22 22.891h-4v9h-7v4h7v5.253l-6.788 2.909 1.575 3.677 5.683-2.436A12.014 12.014 0 0 0 30 54h4a12.014 12.014 0 0 0 11.529-8.707l5.683 2.436 1.575-3.677L46 41.143v-5.252h7Zm-21-20c1.484 0 6 0 6 7H26c0-7 4.516-7 6-7ZM42 42a8.009 8.009 0 0 1-8 8h-4a8.009 8.009 0 0 1-8-8V26.891h20V42Z", fill: "currentColor" })));
